import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { useSignal } from "@preact/signals";
import Table from "../Table";
import Gauge from "../Gauge";
import InlineHelp from "../InlineHelp";
import style from "./style.module.scss";
export function getLoaderHeight(numberOfRules) {
    return numberOfRules * 40 + 32; // each row is 40px and table header is 32px
}
export default function ImproveTable(props) {
    const { data, numberOfRules, ruleColumnName, hideGauge, improveURL, filter } = props;
    const table = [];
    let numberRules = 0;
    if (!("error" in data)) {
        for (const key in data.categories) {
            if (data.categories.hasOwnProperty(key)) {
                if (key === "LIGHTHOUSE_PERFORMANCE") {
                    for (const rule of data.categories[key].rules) {
                        // Check if we have enough rules to show
                        if (numberRules >= numberOfRules) {
                            break;
                        }
                        // skip any rules if they don't match the filter
                        if (filter) {
                            let skipRule = true;
                            if (rule.metrics) {
                                rule.metrics.forEach((metric) => {
                                    if (filter === metric.acronym) {
                                        skipRule = false;
                                    }
                                });
                            }
                            if (skipRule) {
                                continue;
                            }
                        }
                        let color = "var(--warning-color)";
                        let impact = 0;
                        if (rule.impact) {
                            impact = rule.impact;
                        }
                        let averageImpact = 0;
                        if (rule.averageImpact) {
                            averageImpact = rule.averageImpact;
                        }
                        let pageLabelsPercent = 0;
                        if (rule.pageLabelsPercent) {
                            pageLabelsPercent = rule.pageLabelsPercent;
                        }
                        if (averageImpact > 75 || impact > 75) {
                            color = "var(--bad-color)";
                        }
                        if (averageImpact > 0 || impact > 0) {
                            let gauge = null;
                            if (!hideGauge) {
                                gauge = (_jsx("td", { children: _jsx(Gauge, { value: pageLabelsPercent, max: 100, suffix: "%" }) }));
                            }
                            if (improveURL) {
                                table.push(_jsxs("tr", { children: [_jsx("td", { children: _jsxs("div", { className: classNames(style["improve__rule"]), children: [_jsx("div", { className: classNames(style["improve__dot"]), style: {
                                                            backgroundColor: color,
                                                        } }), _jsx(ImproveTableRow, { id: rule.id, name: rule.name, description: rule.description, metrics: rule.metrics, improveURL: improveURL, results: rule.results, hideGauge: hideGauge })] }) }), gauge] }));
                            }
                            else {
                                table.push(_jsxs("tr", { children: [_jsx("td", { children: _jsxs("div", { className: classNames(style["improve__rule"]), children: [_jsx("div", { className: classNames(style["improve__dot"]), style: {
                                                            backgroundColor: color,
                                                        } }), _jsx(ImproveTableRow, { id: rule.id, name: rule.name, description: rule.description, metrics: rule.metrics, improveURL: improveURL, results: rule.results, hideGauge: hideGauge })] }) }), gauge] }));
                            }
                            numberRules++;
                        }
                    }
                }
            }
        }
    }
    let pages = null;
    if (!hideGauge) {
        pages = _jsx("th", { style: { width: "20%" }, children: "% Pages Impacted" });
    }
    let columnName = "Recommendations";
    if (ruleColumnName) {
        columnName = ruleColumnName;
    }
    const noRules = [];
    if (filter && numberRules === 0) {
        noRules.push(_jsxs("p", { style: { marginTop: "10px" }, children: ["No recommendations found to improve ", filter, "."] }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs(Table, { className: "qa-improve-table", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { style: { width: "80%" }, children: columnName }), pages] }) }), _jsx("tbody", { children: table })] }), noRules] }));
}
function ImproveTableRow(props) {
    const { id, name, description, metrics, improveURL, results } = props;
    const expanded = useSignal(false);
    function onClicked() {
        if (!improveURL) {
            expanded.value = !expanded.value;
        }
    }
    const metricElements = [];
    const impacted = [];
    if (metrics) {
        metrics.forEach((metric) => {
            metricElements.push(_jsx(InlineHelp, { info: "Fixing this issue will improve " + metric.name + " (" + metric.acronym + ")", children: _jsx("span", { className: classNames(style["improve__metric"]), children: metric.acronym }) }));
        });
    }
    const renderItem = () => {
        if (improveURL) {
            return (_jsxs("a", { href: improveURL, children: [name, " ", metricElements] }));
        }
        return (_jsxs(_Fragment, { children: [name, " ", metricElements] }));
    };
    if (results) {
        impacted.push(_jsxs(_Fragment, { children: [_jsx("p", { children: "Impacted pages:" }), _jsx("ul", { children: results.map((result) => (_jsx("li", { children: _jsx("a", { href: `${window.accountUrl}/test/${result.testId}/#lighthouse-perf-${id}`, children: result.pageLabel ? result.pageLabel : result.url }) }, id))) })] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx("span", { onClick: onClicked, className: classNames(style["improve__name"]), children: renderItem() }), expanded.value ? (_jsxs(_Fragment, { children: [_jsx("div", {}), _jsxs("div", { className: classNames(style["improve__description"]), children: [_jsx("span", { dangerouslySetInnerHTML: { __html: description } }), impacted] })] })) : null] }));
}
